/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Pricing_Feat3Inputs */

const en_cp_pricing_feat3 = /** @type {(inputs: Cp_Pricing_Feat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builder & Problem Solver templates`)
};

const id_cp_pricing_feat3 = /** @type {(inputs: Cp_Pricing_Feat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template Builder & Problem Solver`)
};

/**
* | output |
* | --- |
* | "Builder & Problem Solver templates" |
*
* @param {Cp_Pricing_Feat3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_pricing_feat3 = /** @type {((inputs?: Cp_Pricing_Feat3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Pricing_Feat3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_pricing_feat3(inputs)
	return en_cp_pricing_feat3(inputs)
});